import { cmsToMts, mtsToCms, getMts2 } from '@/utils/unitConversion'

export function productCost(product) {
    const productAreaM2 = getMts2(product.width, product.height)
    const productQty = parseFloat(product.qty)
    var unitCost = 0
    var totalCost = 0
    var unitProcessCost = 0
    var unitSuppliesCost = 0
    var totalProcessCost = 0
    var totalSuppliesCost = 0
    // product.product_receta.forEach(r => {
    //     const price = parseFloat(r.price)
    //     const min_price = parseFloat(r.min_price)
    //     var subUnitCost = 0
    //     var subTotalCost = 0
    //     if (r.unit === 1) {
    //         //Costos por Metro Cuadrado
    //         subUnitCost = price * productAreaM2
    //         subTotalCost = subUnitCost * productQty

    //         //función antígua
    //         //unitCost += price * qty * productAreaM2
    //         //totalCost += price * qty * productAreaM2 * productQty
    //     } else if (r.unit === 2) {
    //         // costos por unidad
    //         subUnitCost = price
    //         subTotalCost = subUnitCost * productQty

    //         //Función Antígua
    //         //unitCost += price * qty
    //         //totalCost += price * qty * productQty
    //     } else {
    //         //costos por valor fijo
    //         subUnitCost = price
    //         subTotalCost = price
    //     }
    //     //Chequeo si el costo es menor que el mínimo
    //     if (subTotalCost < min_price) {
    //         totalProcessCost += min_price
    //         unitProcessCost += min_price / productQty
    //     } else {
    //         totalProcessCost += subTotalCost
    //         unitProcessCost += subUnitCost
    //     }
    // })

    //Uso la nueva propiedad product.recipe porque incluye
    // la cantidades en los procesos    
    product.recipe.forEach(r => {
        const price = parseFloat(r.price)
        const min_price = parseFloat(r.min_price)
        const qty = parseFloat(r.qty) || 1
        const merma = parseFloat(r.merma) || 0
        var subUnitCost = 0
        var subTotalCost = 0
        if (r.unit === 1) {
            //Costos por Metro Cuadrado
            subUnitCost = price * productAreaM2 * qty
            subTotalCost = subUnitCost * productQty

            //función antígua
            //unitCost += price * qty * productAreaM2
            //totalCost += price * qty * productAreaM2 * productQty
        } else if (r.unit === 2) {
            // costos por unidad
            subUnitCost = price * qty
            subTotalCost = subUnitCost * productQty + price * merma //Incluyo la merma en el costo total

            //Función Antígua
            //unitCost += price * qty
            //totalCost += price * qty * productQty
        } else {
            //costos por valor fijo
            subTotalCost = price * qty
            subUnitCost = subTotalCost / productQty
        }
        //Chequeo si el costo es menor que el mínimo
        if (subTotalCost < min_price) {
            totalProcessCost += min_price
            unitProcessCost += min_price / productQty
        } else {
            totalProcessCost += subTotalCost
            unitProcessCost += subUnitCost
        }
    })


    //Sumo el costo de suministros que incluye la cantidad
    product.product_supplies.forEach(r => {
        const price = parseFloat(r.price)
        const min_price = parseFloat(r.min_price)
        const qty = parseFloat(r.qty) || 1
        var subUnitCost = 0
        var subTotalCost = 0
        if (r.unit === 1) {
            //Costos por Metro Cuadrado
            subUnitCost = price * qty * productAreaM2
            subTotalCost = subUnitCost * productQty

        } else if (r.unit === 2) {
            // costos por unidad
            subUnitCost = price * qty
            subTotalCost = subUnitCost * productQty
            if (r.has_dimension) {
                console.log('Tiene dimensión', r, productQty, qty)
                console.log('Cálculo:', price, '*', Math.ceil(productQty * qty))
                subTotalCost = price * Math.ceil(productQty * qty)
                subUnitCost = subTotalCost / productQty
            }

        } else {
            //costos por valor fijo
            subTotalCost = price * qty
            subUnitCost = subTotalCost / productQty
        }
        //Chequeo si el costo es menor que el mínimo
        if (subTotalCost < min_price) {
            totalSuppliesCost += min_price
            unitSuppliesCost += min_price / productQty
        } else {
            totalSuppliesCost += subTotalCost
            unitSuppliesCost += subUnitCost
        }
    })

    unitCost = unitProcessCost + unitSuppliesCost
    totalCost = totalProcessCost + totalSuppliesCost

    return {
        unit: unitCost,
        total: totalCost,
        unitSupplies: unitSuppliesCost,
        unitProcess: unitProcessCost,
        totalSupplies: totalSuppliesCost,
        totalProcess: totalProcessCost,
        mts2: productAreaM2,
        totalMts2: productAreaM2 * productQty
    }
}



export function calcSheets(product, supply) {
    const pw = parseFloat(product.width || 0)
    const ph = parseFloat(product.height || 0)
    const sw = parseFloat(supply.width || 0)
    const sh = parseFloat(supply.height || 0)
    const pq = parseFloat(product.qty || 1)

    if (pw === 0 || ph === 0 || sw === 0 || sh === 0) return 0

    //Orientacion directa
    const res1 = Math.floor(sw / pw) * Math.floor(sh / ph)

    //Orientacion inversa
    const res2 = Math.floor(sh / pw) * Math.floor(sw / ph)

    //Productos por plancha
    const product_per_sheet = Math.max(res1, res2)
    if (product_per_sheet === 0) return 0

    //Cantidad de Planchas
    const sheets_qty = Math.ceil(pq / product_per_sheet)

    return sheets_qty
}
//Indica si la pieza cabe en la plancha en alguna orientación (true si no hay medidas para comparar)
export function fitsInSheet(product, supply) {
    const pw = parseFloat(product.width || 0)
    const ph = parseFloat(product.height || 0)
    const sw = parseFloat(supply.width || 0)
    const sh = parseFloat(supply.height || 0)
    if (pw === 0 || ph === 0 || sw === 0 || sh === 0) return true
    return (pw <= sw && ph <= sh) || (pw <= sh && ph <= sw)
}

//Mismas reglas que valida el backend (sales/quotation_rules.py) al guardar la cotización y al crear la OT
export function quotationProductErrors(products) {
    const num = v => parseFloat(v || 0) || 0
    const errors = []
    ;(products || []).forEach((product, i) => {
        const prefix = `Línea ${i + 1} "${product.name || `Producto ${i + 1}`}"`
        if (num(product.qty) <= 0) errors.push(`${prefix}: la cantidad debe ser mayor a 0`)
        if (num(product.totalMts2) <= 0) errors.push(`${prefix}: los m2 deben ser mayores a 0`)
        if (num(product.width) <= 0) errors.push(`${prefix}: el ancho debe ser mayor a 0`)
        if (num(product.height) <= 0) errors.push(`${prefix}: el alto debe ser mayor a 0`)
        ;(product.product_supplies || []).forEach(supply => {
            const supplyPrefix = `${prefix}, material "${supply.name || ''}"`
            if (num(supply.qty) <= 0) {
                if (supply.has_dimension && !fitsInSheet(product, supply)) {
                    errors.push(`${supplyPrefix}: la pieza (${product.width} x ${product.height} cm) no cabe en la plancha (${supply.width} x ${supply.height} cm)`)
                } else {
                    errors.push(`${supplyPrefix}: la cantidad debe ser mayor a 0`)
                }
            }
            if (num(supply.unit) <= 0) errors.push(`${supplyPrefix}: falta la unidad`)
            if (num(supply.price) < 0) errors.push(`${supplyPrefix}: el precio no puede ser negativo`)
            if (num(supply.min_price) < 0) errors.push(`${supplyPrefix}: el precio mínimo no puede ser negativo`)
        })
    })
    return errors
}
